/* unplugin-vue-components disabled */import { render } from "./topSwiper.vue?vue&type=template&id=35d9c027&scoped=true"
import script from "./topSwiper.vue?vue&type=script&lang=js"
export * from "./topSwiper.vue?vue&type=script&lang=js"

import "./topSwiper.vue?vue&type=style&index=0&id=35d9c027&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d9c027"]])

export default __exports__